"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Spinner_1 = require("avatar-client/lib/react/components/Spinner/Spinner");
var FormFields_1 = require("./FormFields");
var hooks_1 = require("./hooks");
var defaultValues = {
    anrede: '',
    vorname: '',
    nachname: '',
    email: '',
    agreed: false
};
var cleanUrl = function (v) { return v.replace(/(:\/\/)|(\/)+/g, '$1$2'); };
function Invite(_a) {
    var _this = this;
    var apiBaseUrl = _a.apiBaseUrl, inviteKey = _a.inviteKey, botName = _a.avatarDisplayName, botPictureUrl = _a.avatarPictureUrl, videoUrl = _a.videoUrl, videoPosterUrl = _a.videoPosterUrl, agreementUrl = _a.agreementUrl, extraStylesheet = _a.extraStylesheet, props = __rest(_a, ["apiBaseUrl", "inviteKey", "avatarDisplayName", "avatarPictureUrl", "videoUrl", "videoPosterUrl", "agreementUrl", "extraStylesheet"]);
    var video = react_1.default.createRef();
    hooks_1.useVideoAutoplay(video, 640);
    hooks_1.useExtraStylesheet(extraStylesheet);
    var _b = react_1.default.useState('form'), formState = _b[0], setFormState = _b[1];
    var _c = react_1.default.useState(defaultValues), formValues = _c[0], setValues = _c[1];
    var handleChange = react_1.default.useCallback(function (_a) {
        var target = _a.target;
        var name = target.name;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        setValues(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[name] = value, _a)));
        });
    }, [setValues]);
    var sendRequest = react_1.default.useCallback(function (recaptcha) { return __awaiter(_this, void 0, void 0, function () {
        var url, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setFormState('submitting');
                    console.log("Submit to: " + apiBaseUrl + "/selfinvite/" + inviteKey);
                    url = cleanUrl(apiBaseUrl + "/selfinvite/" + inviteKey);
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(__assign({ recaptcha: recaptcha }, formValues))
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    setFormState('success');
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('submit failed', error_1);
                    setFormState('error');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [formValues, apiBaseUrl, inviteKey]);
    var handleSubmit = react_1.default.useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        sendRequest();
    }, [sendRequest]);
    react_1.default.useEffect(function () { return document.body.classList.add('client-ready'); }, []);
    return (react_1.default.createElement("div", __assign({ className: 'Invite' }, props),
        react_1.default.createElement("video", { ref: video, src: videoUrl, poster: videoPosterUrl, preload: 'none', playsInline: true, loop: true, muted: true }),
        inviteKey && (react_1.default.createElement("div", { className: 'Panel' },
            react_1.default.createElement("header", null,
                react_1.default.createElement("div", { className: 'portrait' },
                    react_1.default.createElement("img", { src: botPictureUrl, alt: 'avatar' })),
                botName),
            (formState === 'form' ||
                formState === 'recaptcha' ||
                formState === 'submitting') && (react_1.default.createElement("form", { onSubmit: handleSubmit },
                react_1.default.createElement("div", { className: 'content' },
                    react_1.default.createElement("h3", null,
                        "Dialog mit ",
                        botName,
                        " starten"),
                    react_1.default.createElement("p", null,
                        "Sch\u00F6n, dass Sie den Dialog mit ",
                        botName,
                        " f\u00FChren m\u00F6chten!"),
                    react_1.default.createElement("p", null, "Um sicherzustellen, dass Sie selbst den Dialog durchf\u00FChren, erhalten Sie einen Einladungs-Link per E-Mail."),
                    react_1.default.createElement("p", null, "Bitte tragen Sie hierf\u00FCr die notwendigen Informationen ein."),
                    react_1.default.createElement(FormFields_1.FormFields, { agreementUrl: agreementUrl, onChange: handleChange, values: formValues })),
                react_1.default.createElement("footer", null,
                    react_1.default.createElement("span", { className: 'spacer' }),
                    react_1.default.createElement("button", { type: 'submit' }, "Einladung senden")))),
            formState === 'submitting' && (react_1.default.createElement("div", { className: 'overlay loading-overlay' },
                react_1.default.createElement(Spinner_1.Spinner, null))),
            formState === 'success' && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'content' },
                    react_1.default.createElement("h3", null, "Vielen Dank"),
                    react_1.default.createElement("p", null, "Gleich geht es los. Sie erhalten in K\u00FCrze eine E-Mail von uns."),
                    react_1.default.createElement("p", null,
                        "Diese beinhaltet den Einladungs-Link zu Ihrem pers\u00F6nlichen Dialog. Per Mausklick werden Sie dann zu ",
                        botName,
                        ' ',
                        "weitergeleitet.")),
                react_1.default.createElement("footer", null,
                    react_1.default.createElement("button", { type: 'submit', onClick: function () {
                            setFormState('form');
                            setValues(defaultValues);
                        } }, "Zur\u00FCck zum Formular"),
                    react_1.default.createElement("span", { className: 'spacer' })))),
            formState === 'error' && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'content' },
                    react_1.default.createElement("h3", null, "Das hat leider nicht geklappt."),
                    react_1.default.createElement("p", null, "Da hat sich wohl ein Fehler eingeschlichen.")),
                react_1.default.createElement("footer", null,
                    react_1.default.createElement("button", { type: 'submit', onClick: function () {
                            setFormState('form');
                        } }, "Zur\u00FCck zum Formular"),
                    react_1.default.createElement("span", { className: 'spacer' }))))))));
}
exports.Invite = Invite;
